/**
* Standard router outlet names
*/
export const RoutePartType = {
    'body': 'body',
    'sidebar': 'sidebar',
    'head': 'head',
    'primary': 'primary'
};
